/*
import React from 'react';
import { isMobile } from '@/utils';

export default function (props) {
  const Component = isMobile()
    ? require('./AuthResult').default
    : require('./WebAuthResult').default;
  return <Component {...props} />;
}
*/


import Faceauthb from './Faceauthb';

export default Faceauthb;
